import { responseSchema } from '@/core/types/Response.ts'
import { z } from 'zod'
import { creditUnpaySchema } from '@/modules/sales/clients/types/CreditUnpay.ts'

export const creditUnpayResponseSchema = responseSchema(creditUnpaySchema)

export type CreditUnpayResponse = z.infer<typeof creditUnpayResponseSchema>
